import { array, boolean, object, string } from 'yup'
import { t } from 'ttag'

import {
  CATEGORY_TITLE_FIELD,
  DESCRIPTION_FIELD,
  QUESTIONS_GROUP_FIELD,
  QUESTION_FIELD,
  SCOREABLE_FIELD,
} from './model'

export const CATEGORY_TITLE_FIELD_LIMIT = 30

export const getSchema = () =>
  object().shape({
    [CATEGORY_TITLE_FIELD]: string()
      .max(
        CATEGORY_TITLE_FIELD_LIMIT,
        t`Category title cannot exceed 30 characters.`,
      )
      .required(t`This field cannot be empty.`),
    [SCOREABLE_FIELD]: boolean().oneOf([true, false]).required(),
    [QUESTIONS_GROUP_FIELD]: array().of(
      object().shape({
        [QUESTION_FIELD]: string().required(t`This field cannot be empty.`),
        [DESCRIPTION_FIELD]: string().optional(),
      }),
    ),
  })
